import { AuthGuard } from "@aihub/core/authorization";
import { Routes } from "@angular/router";
import { environment } from "@environments/environment";
import { DeployGuard } from "@shared/entitlements/utils/deploy.guard";

export const appRoutes: Routes = [{
    path: "",
    redirectTo: "catalog",
    pathMatch: "full"
}, {
    path: "catalog",
    loadChildren: () => import("@brain/catalogs/catalog.module").then((m) => m.BrainCatalogModule),
    data: {
        breadcrumb: environment.breadcrumbs.store.storefront
    }
}, {
    path: "entitlements",
    loadChildren: () => import("@shared/entitlements/entitlements.module").then((m) => m.EntitlementsModule),
    data: {
        breadcrumb: (): string | null => {
            const isLast = location.pathname.match(/^\/entitlements$/);
            return isLast ? null : "My Entitlements";
        }
    }
}, {
    path: "purchases",
    loadChildren: () => import("../pages/purchases/purchase.module").then((m) => m.PurchaseModule),
    data: {
        breadcrumb: environment.breadcrumbs.store.orderHistory
    }
}, {
    path: "deployment",
    canActivate: [DeployGuard],
    loadChildren: () => import("@shared/deploy/deploy.module").then((m) => m.DeployModule)
}, {
    path: "jwt",
    canActivate: [AuthGuard],
    loadChildren: () => import("@shared/display-jwt/display-jwt.module").then((m) => m.DisplayJwtModule),
}];
